<div class="error-parent">
  <div class="error-setup">
    <div class="row">
      <div class="col-12">
        <div class="error-flow">
          <div class="heading" [ngSwitch]="errorCode">
            <ng-container *ngSwitchCase="404">
              Oops. We can’t find the page you’re looking for
            </ng-container>
            <ng-container *ngSwitchDefault>
              Something went wrong
            </ng-container>
          </div>
          <div class="error-subheading-container">
            <div class="subheading">Even the best of us have technical difficulties sometimes. </div>
            <button mat-flat-button color="accent" (click)="navigateToDashboard()">Back to home</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="background-width">
  </div>
</div>
